import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
import * as AppUrls from "../../../constants/AppUrls";
import NavbarOnboarding from "../NavbarOnboarding/NavbarOnboarding";
import KYCimg from "../../../assets/images/Sharjah/KYC.png";
import "./SignatureForm.modules.css";
import "./FatcaDeclaration.modules.css";
import SignatureCanvas from "react-signature-canvas";
import i18next from "i18next";
import * as Constants from "../../../constants/Constants";
import * as Helpers from "../../../global/Helpers";
import * as utils from "../../../global/utils";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import SessionExpiredPOPup from "../SessionExpiredPOPup/SessionExpiredPOPup";

const SignatureForm = () => {
  const { t } = useTranslation();
  const [redirect, setRedirect] = useState(null);
  const sigCanvas = useRef({});
  const [signature, setSignature] = useState(null);
  const [City, setCity] = useState([]);
  const [Countries, setCountries] = useState([]);
  const [IsCallAPI, setIsCallAPI] = useState(false);
  const [isNotUSCitizen, setisNotUSCitizen] = useState(false);
  const [formState, setFormState] = useState({
    Signature: "",
    Address: "",
    country: "",
    City: "",
    BoxNo: "",
    EMIRATES_ID: "",
  });
  const [indexOFPage, setIndexOFPage] = useState(1);
  const [IsCallAPIOnce, setIsCallAPIOnce] = useState(false);

  useEffect(() => {
    fetchCountries();
  }, [i18next.language]);

  useEffect(() => {
    ;
    if (IsCallAPIOnce) {
      if (!validateSubmit()) return;

    var result = Helpers.getScreenIdByGroupAndName("signature screen");


      var Items = [
        { ID: "21", Value: formState.Address },
        { ID: "107", Value: formState.country },
        { ID: "11", Value: formState.City },
        { ID: "15", Value: formState.BoxNo },
        { ID: "288", Value: result?.GROUP_ID || "" },
        { ID: "287", Value: result?.SCREEN_ID || "" },
        // { ID: "51", Value: formState.EMIRATES_ID },
        { ID: "258", Value: "1" },
      ];
      saveKycData(Items);
    }
  }, [IsCallAPIOnce]);

  function validateSubmit() {
    ;
    // if (formState.EMIRATES_ID === "") {
    //   Helpers.errorNotify(t("Please fill Emirates ID"), i18next.language);
    //   setIsCallAPIOnce(false);
    //   return false;
    // }

    // if (formState.EMIRATES_ID.length > 15 || formState.EMIRATES_ID.length < 15) {
    //   Helpers.errorNotify(t("Emirates ID must be exactly 15 digits."));
    //   setIsCallAPIOnce(false);
    //   return false;
    // }
    if (formState.Address === "") {
      Helpers.errorNotify(t("Please fill Address"), i18next.language);
      setIsCallAPIOnce(false);
      return false;
    }
    if (formState.country === "") {
      Helpers.errorNotify(t("Please fill country"), i18next.language);
      setIsCallAPIOnce(false);
      return false;
    }
    if (formState.City === "") {
      Helpers.errorNotify(t("Please fill City"), i18next.language);
      setIsCallAPIOnce(false);
      return false;
    }
    if (formState.BoxNo === "") {
      Helpers.errorNotify(t("Please fill PO Box No."), i18next.language);
      setIsCallAPIOnce(false);
      return false;
    }

    return true;
  }

  const handleChange = (event) => {
    ;
    const { name, value } = event.target;
    setFormState({
      ...formState,
      [name]: value,
    });
    if (name === "country") {
      fetchCity(value);
    }
  };

  // Function to clear the signature pad
  const clearSignature = () => {
    sigCanvas.current.clear();
    setSignature(null);
  };

  // Function to save the signature as an image URL
  // const saveSignature = async () => {
  //   ;
  //   setSignature(sigCanvas.current.getTrimmedCanvas().toDataURL("image/jpeg"));
  //   const dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/jpeg");


  //   // Decode base64 into a binary string
  //   const byteString = atob(dataURL.split(",")[1]);

  //   // Convert the binary string to a byte array (Uint8Array)
  //   const byteArray = new Uint8Array(byteString.length);
  //   for (let i = 0; i < byteString.length; i++) {
  //     byteArray[i] = byteString.charCodeAt(i);
  //   }

  //   var bytesString = [].slice.call(byteArray);
  //   // var FileType = file.type;
  //   // FileType = FileType.split('/');
  //   // if (FileType !== null)
  //   //     FileType = FileType[1];

  //   const body = {
  //     fields: [{ DocType: "JPEG", field_id: "106", field_value: bytesString }],
  //     RequestId: localStorage.getItem("RID"),
  //   };
  //   const body2 = {
  //     field_value: bytesString,
  //   };

  //   var response = utils.CallInsertAttachments(
  //     Constants.InsertAttachments,
  //     body
  //   );
  //   await response
  //     .then((response) => {
  //       ;
  //       if (response.data.ErrorMsg === "success") {
  //         Helpers.successNotify(t("Signature Uploaded Successfully"));
  //       } else if (response.data.ErrorMsg === "Invalid token") {
  //         confirmAlert({
  //           customUI: ({ onClose }) => {
  //             return (
  //               <SessionExpiredPOPup
  //                 setRedirect={setRedirect}
  //                 onClose={onClose}
  //               />
  //             );
  //           },
  //         });
  //       } else {
  //         Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("CallInsertAttachments", error);
  //     });

  //   var responseICAP = utils.CallICAPScanningFile(
  //     Constants.ICAPScanningFile,
  //     body2
  //   );
  //   await responseICAP
  //     .then((responseICAP) => {
  //       ;
  //       console.log("test");
  //     })
  //     .catch((error) => {
  //       console.log("CallICAPScanningFile", error);
  //     });
  // };

  const saveSignature = async () => {
  ;

  // 1. احصل على الـ trimmed canvas
  const trimmedCanvas = sigCanvas.current.getTrimmedCanvas();

  // 2. إنشاء canvas مؤقت بنفس الحجم
  const canvas = document.createElement("canvas");
  canvas.width = trimmedCanvas.width;
  canvas.height = trimmedCanvas.height;

  const ctx = canvas.getContext("2d");

  // 3. رسم خلفية بيضاء
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // 4. نسخ التوقيع فوق الخلفية
  ctx.drawImage(trimmedCanvas, 0, 0);

  // 5. تحويل الـ canvas إلى dataURL بصيغة JPEG
  const dataURL = canvas.toDataURL("image/jpeg");

  // 6. اختياري: معاينة الصورة الناتجة في المتصفح (للتأكد من النتيجة)
  // const img = new Image();
  // img.src = dataURL;
  // document.body.appendChild(img);

  // 7. تخزين نسخة البيانات في الحالة إذا لزم
  setSignature(dataURL);

  // 8. تحويل base64 إلى binary
  const byteString = atob(dataURL.split(",")[1]);

  // 9. تحويل إلى Uint8Array
  const byteArray = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    byteArray[i] = byteString.charCodeAt(i);
  }

  const bytesString = Array.from(byteArray); // الأفضل استخدام Array.from

  // 10. تجهيز الـ body
  const body = {
    fields: [{ DocType: "JPEG", field_id: "106", field_value: bytesString }],
    RequestId: localStorage.getItem("RID"),
  };

  const body2 = {
    field_value: bytesString,
  };

  // 11. إرسال البيانات
  try {
    const response = await utils.CallInsertAttachments(Constants.InsertAttachments, body);

    if (response.data.ErrorMsg === "success") {
      Helpers.successNotify(t("Signature Uploaded Successfully"));
    } else if (response.data.ErrorMsg === "Invalid token") {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <SessionExpiredPOPup setRedirect={setRedirect} onClose={onClose} />
          );
        },
      });
    } else {
      Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
    }
  } catch (error) {
    console.log("CallInsertAttachments", error);
  }

  // 12. ICAP Scan
  try {
    const responseICAP = await utils.CallICAPScanningFile(Constants.ICAPScanningFile, body2);
    console.log("ICAP response", responseICAP);
  } catch (error) {
    console.log("CallICAPScanningFile", error);
  }
};


  const handleProceed = () => {
    if (indexOFPage < 3) setIndexOFPage(indexOFPage + 1);
  };

  const handlePrevious = () => {
    setisNotUSCitizen(false);
    if (indexOFPage !== 1) setIndexOFPage(indexOFPage - 1);
  };
  const handleBack = (e) => {
    e.preventDefault();
    setRedirect(AppUrls.onboardingPersonal);
  };

  const fetchCity = async (CountryCode) => {
    ;
    try {
      const data = {
        CountryCode: CountryCode,
        Lang: i18next.language === "ar" ? "AR" : "EN",
      };
      var response = utils.CallKYCAPI(Constants.GetCities, data);
      await response
        .then((response) => {
          ;
          if (response.data.ErrorMsg === "success") {
            setCity(response.data.resData);
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            setCity([]);
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("fetchCity", error);
        });
    } catch (error) {
      console.error("Error posting data fetchCity:", error);
    }
  };

  const fetchCountries = async () => {
    ;
    try {
      const data = { Lang: i18next.language === "ar" ? "AR" : "EN" };
      var response = utils.CallKYCAPI(Constants.GetCountriesLookup, data);
      await response
        .then((response) => {
          ;
          if (response.data.ErrorMsg === "success") {
            setCountries(response.data.resData);
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            setCountries([]);
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("fetchCountries", error);
        });
    } catch (error) {
      console.error("Error posting data fetchCountries:", error);
    }
  };

  const handleNextForCallAPISave = () => {
    ;
    setIsCallAPI(true);
    if (indexOFPage === 1) {
      setIsCallAPIOnce(true);
    }
    // handleProceed();
  };

  const saveKycData = async (Items) => {
    try {
      const body = {
        RequestItems: Items,
        reqID: localStorage.getItem("RID"),
      };

      var response = utils.CallKYCAPI(Constants.GetKYCCibc, body);
      await response
        .then((response) => {
          ;
          if (response.data.Error_code === "0") {
            setIsCallAPI(false);
            setIsCallAPIOnce(false);

            if (indexOFPage >= 3) {
              setRedirect(AppUrls.onboardingMain);
            } else if (indexOFPage === 2 && isNotUSCitizen) {
              setRedirect(AppUrls.onboardingMain);
            } else handleProceed();

            // if (indexOFPage >= 3) setRedirect(AppUrls.onboardingMain);
            // else handleProceed();
          } else if (response.data.Error_code === "-1") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            Helpers.errorNotify(response.data.Error_Msg, i18next.language);
            setIsCallAPI(false);
            setIsCallAPIOnce(false);
          }
        })
        .catch((error) => {
          console.log("saveKycData", error);
          setIsCallAPI(false);
          setIsCallAPIOnce(false);
        });
    } catch (error) {
      setIsCallAPI(false);
      setIsCallAPIOnce(false);
      console.error("Error posting data saveKycData:", error);
    }
  };
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }
  return (
    <>
      <NavbarOnboarding />
      <div className="login-main-container">
        <div className="KYCDivImg">
          <h2 className="OpenYourAccountwithUs">{t("OpenYourAccountwithUs")}</h2>
          <img className="KYCImg" src={KYCimg} />
        </div>
        <div className="QRCode-container">
          <div className="QRCode-form">
            <div className="signature-form-container">
              {indexOFPage === 1 ? (
                <>
                  <h2>{t("createyoursignature")}</h2>
                  {/* <div className="signature-box">
                                        <textarea
                                            name='Signature'
                                            value={formState.Signature}
                                            onChange={handleChange}
                                        />
                                    </div> */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <SignatureCanvas
                      ref={sigCanvas}
                      penColor="black"
                      canvasProps={{
                        width: 350,
                        height: 150,
                        className: "sigCanvas",
                      }}
                    />
                  </div>

                  {/* Buttons to clear or save the signature */}
                  <span className="signatureBtn">
                    <button className="prev-btn" onClick={clearSignature}>
                      {t("btnClear")}
                    </button>
                    <button className="prev-btn" onClick={saveSignature}>
                      {t("save")}
                    </button>
                  </span>
                  {/* Display the saved signature */}
                  {/* {signature && (
                                        <div>
                                            <h2>{t("YourSignature")}</h2>
                                            <img src={signature} alt="User signature" />
                                        </div>
                                    )} */}
                  {/* <label>{t("EMIRATES_ID")}</label>
                  <input type="text" id="textEMIRATES_ID" name="EMIRATES_ID" value={formState.EMIRATES_ID} onChange={handleChange} placeholder={t("enterEMIRATES_ID")} required /> */}

                  <label>{t("address")}</label>
                  <input
                    type="text"
                    id="textAddress"
                    name="Address"
                    value={formState.Address}
                    onChange={handleChange}
                    placeholder={t("enterAddress")}
                    required
                  />

                  <label>{t("Country")}</label>
                  <select
                    id="dropdown1"
                    name="country"
                    value={formState.country}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="" disabled>
                      {t("select_country")}
                    </option>
                    {Countries.map((obj) => {
                      return (
                        <option value={obj.C_CODE}>{obj.countryName}</option>
                      );
                    })}
                  </select>

                  <label>{t("City")}</label>
                  <select
                    id="dropdown1"
                    name="City"
                    value={formState.City}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="" disabled>
                      {t("select_City")}
                    </option>
                    {City.map((obj) => {
                      return (
                        <option value={obj.CityCode}>{obj.CityName}</option>
                      );
                    })}
                  </select>

                  <label>{t("po_box_no")}</label>
                  <input
                    type="text"
                    id="textBoxNo"
                    name="BoxNo"
                    value={formState.BoxNo}
                    onChange={handleChange}
                    placeholder={t("enterPOBoxNo")}
                    required
                  />
                </>
              ) : indexOFPage === 2 ? (
                <FatcaDeclaration
                  saveKycDataAPI={saveKycData}
                  setIsCallAPI={setIsCallAPI}
                  IsCallAPI={IsCallAPI}
                  setisNotUSCitizen={setisNotUSCitizen}
                />
              ) : indexOFPage === 3 && !isNotUSCitizen ? (
                <CRSDeclarationForm
                  saveKycDataAPI={saveKycData}
                  setIsCallAPI={setIsCallAPI}
                  IsCallAPI={IsCallAPI}
                  Countries={Countries}
                />
              ) : null}

              <div className="buttons">
                {indexOFPage !== 1 ? (
                null
                  // <button className="prev-btn" onClick={handlePrevious}>
                  //   {t("back")}
                  // </button>
                ) : (
                  <button
                    style={{
                      width: "45%",
                      background: "transparent",
                      border: "0",
                    }}
                  ></button>
                )}
                {indexOFPage < 3 ? (
                  <button
                    className="proceed-btn"
                    onClick={handleNextForCallAPISave}
                  >
                    {t("Next")}
                  </button>
                ) : indexOFPage === 3 ? (
                  <button
                    className="proceed-btn"
                    onClick={handleNextForCallAPISave}
                  >
                    {t("Confirm")}
                  </button>
                ) : null}
              </div>
            </div>
            {indexOFPage === 1 ? (
              <div>
                {/* <button
                  className={"link"}
                  style={{
                    width: "100%",
                    textDecoration: "underline",
                    marginTop: "1rem",
                    marginLeft: "auto",
                    marginRight: "auto",
                    background: "transparent",
                    border: "none",
                    color: "#0b1d81",
                    cursor: "pointer",
                  }}
                  onClick={handleBack}>
                  {t("back")}
                </button> */}

                {/* <button className="backBtn" onClick={handleBack}>
                {t("back")}
              </button> */}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default SignatureForm;

const FatcaDeclaration = (props) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    isNotUSCitizen: false,
    hasUSAddress: false,
    hasUSFundsTransfer: false,
    poaHolderUSResident: false,
  });

  const handleCheckboxChange = (event) => {
    ;
    const { name, checked } = event.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
    props.setisNotUSCitizen(checked);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Process the form data (e.g., API call)
    console.log(formData);
  };

  useEffect(() => {
    ;
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  const saveKycDataFun = () => {
    ;
    // if (!validateSubmit())
    //     return;

    var result = Helpers.getScreenIdByGroupAndName("signature screen");
    var Items = [
      { ID: "76", Value: formData.hasUSAddress ? "Y" : "N" },
      { ID: "233", Value: formData.hasUSFundsTransfer ? "Y" : "N" },
      { ID: "78", Value: formData.poaHolderUSResident ? "Y" : "N" },
      { ID: "73", Value: formData.isNotUSCitizen ? "Y" : "N" },
      { ID: "288", Value: result?.GROUP_ID || "" },
      { ID: "287", Value: result?.SCREEN_ID || "" },
      { ID: "258", Value: "1" },
    ];

    props.saveKycDataAPI(Items);
  };

  return (
    <div className="fatca-form-container">
      <h2>{t("FATCADeclaration")}</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-section">
          <label style={{ display: "flex" }}>
            <input
              type="checkbox"
              name="isNotUSCitizen"
              style={{ width: "3%", marginBottom: "0", marginInlineEnd: "2%" }}
              checked={formData.isNotUSCitizen}
              onChange={handleCheckboxChange}
            />
            {t("not_usa_citizen")}
          </label>
        </div>
        <hr style={{ width: "100%" }} />
        <div className="form-section">
          <label>{t("residence_address_in_us")}</label>
          <label className="switch">
            <input
              type="checkbox"
              name="hasUSAddress"
              checked={formData.hasUSAddress}
              onChange={handleCheckboxChange}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <hr style={{ width: "100%" }} />

        <div className="form-section">
          <label>{t("standing_instructions_to_us_account")}</label>
          <label className="switch">
            <input
              type="checkbox"
              name="hasUSFundsTransfer"
              checked={formData.hasUSFundsTransfer}
              onChange={handleCheckboxChange}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <hr style={{ width: "100%" }} />

        <div className="form-section">
          <label>{t("IsyourPOA")}</label>
          <label className="switch">
            <input
              type="checkbox"
              name="poaHolderUSResident"
              checked={formData.poaHolderUSResident}
              onChange={handleCheckboxChange}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </form>
    </div>
  );
};

const CRSDeclarationForm = (props) => {
  const [country, setCountry] = useState("");
  const [tin, setTin] = useState("");
  const [noTinReason, setNoTinReason] = useState("");
  const { t } = useTranslation();

  const countryOptions = [
    { value: "us", label: "United States" },
    { value: "in", label: "India" },
    // Add more countries
  ];

  // const tinReasons = [
  //     { value: 'A', label: 'The country does not issue TIN' },
  //     { value: 'B', label: 'Unable to obtain TIN' },
  //     { value: 'C', label: 'No TIN is required' },
  // ];

  const tinReasons = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
    { value: "C", label: "C" },
  ];

  useEffect(() => {
    ;
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    ;
    if (country === "") {
      Helpers.errorNotify(t("Please fill country"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }

    if (tin === "") {
      Helpers.errorNotify(t("Please fill tin"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }

    if (noTinReason === "") {
      Helpers.errorNotify(t("select_reason_for_no_tin"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }

    return true;
  }

  const saveKycDataFun = () => {
    ;
    if (!validateSubmit()) return;

    var result = Helpers.getScreenIdByGroupAndName("signature screen");
    var Items = [
      // { ID: "12", Value: country },
      { ID: "234", Value: country },
      { ID: "235", Value: tin },
      { ID: "236", Value: noTinReason },
      { ID: "258", Value: "1" },
      { ID: "288", Value: result?.GROUP_ID || "" },
      { ID: "287", Value: result?.SCREEN_ID || "" },
    ];
    props.saveKycDataAPI(Items);
  };

  return (
    <div className="CRSDeclarationForm-container">
      <h2>{t("FatcaCRSDeclaration")}</h2>
      <div className="form-group">
        <label>{t("CountryOfResidence")}</label>
        <select
          onChange={(e) => setCountry(e.target.value)}
          value={country}
          placeholder={t("select_country")}
        >
          <option value="" disabled>
            {t("select_country")}
          </option>
          {props.Countries.map((obj) => {
            return <option value={obj.C_CODE}>{obj.countryName}</option>;
          })}
        </select>
      </div>

      <div className="form-group">
        <label>{t("enter_tin")}</label>
        <input
          type="text"
          value={tin}
          onChange={(e) => setTin(e.target.value)}
          placeholder={t("enter_tin")}
        />
      </div>

      <div className="form-group">
        <label>{t("select_reason_for_no_tin")}</label>
        <select
          onChange={(e) => setNoTinReason(e.target.value)}
          value={noTinReason}
          placeholder="Please select the reason"
        >
          <option value="" disabled>
            {t("select_reason_for_no_tin")}{" "}
          </option>
          {tinReasons.map((obj) => {
            return <option value={obj.value}>{obj.label}</option>;
          })}
        </select>
      </div>

      {/* <button className="add-more-btn">+ Add More</button> */}
      {i18next.language === "ar" ? (
        <div className="divText">
          <p>
            إذا لم يكن رقم التعريف الضريبي متاحًا، فيرجى تقديم السبب المناسب أ
            أو ب أو ج حيثما هو موضح أدناه
          </p>
          <p>
            {" "}
            أ. الدولة/الولاية القضائية التي يقيم فيها صاحب الحساب لا تصدر رقم
            تعريف ضريبي لسكانها
          </p>
          <p>
            {" "}
            ب. صاحب الحساب غير قادر على الحصول على رقم تعريف ضريبي أو رقم مكافئ
            (يرجى توضيح سبب عدم تمكنك من الحصول على رقم تعريف ضريبي في الجدول
            أدناه إذا قمت بتحديد هذا السبب)
          </p>
          <p>
            {" "}
            ج. لا يلزم الحصول على رقم تعريف ضريبي (ملاحظة: حدد هذا السبب إذا كان
            القانون المحلي للولاية القضائية ذات الصلة لا يتطلب تحصيل رقم التعريف
            الضريبي الصادر عن هذه الولاية القضائية)
          </p>{" "}
        </div>
      ) : (
        <div className="divText">
          <p>
            If a TIN is unavailable please provide the appropriate reason A, B
            or C where indicated below
          </p>
          <p>
            {" "}
            A. The country/jurisdiction where the Account Holder is resident
            does not issue TIN to its residents
          </p>
          <p>
            {" "}
            B. The Account Holder is otherwise unable to obtain a TIN or
            equivalent number (Please explain why you are unable to obtain a TIN
            in the below table if you have selected this reason)
          </p>
          <p>
            {" "}
            C. No TIN is required (Note: Select this reason if the domestic law
            of the relevant jurisdiction does not require the collection of the
            TIN issued by such jurisdiction)
          </p>{" "}
        </div>
      )}
      {/* Add more form logic here */}
    </div>
  );
};
